<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-response></table-response>
    </v-container>
  </div>
</template>

<script>
import TableResponse from "@/components/table/TableResponse";

export default {
  name: "CallbacksList",
  components: {
    TableResponse
  }
};
</script>

<style scoped></style>
